module.exports = __webpack_public_path__ + "static/media/folder.5107a6da.png";